<template>
  <router-link :to="`/articles/${datas.id}`"  :key="datas.id" v-if="category" class="gallery_item">
    <template v-if="datas">
      <div class="gallery_item_thumb">
        <img
          v-if="datas.coverurl"
          :src="datas.coverurl"
          alt="gallery"
          class="custom-img"
        />
      </div>
      <div class="gallery_item_content">
        <div class="post-meta">
          <div class="meta-categories">
            <router-link :to="`/articles?channel=${datas.orgchannel}`">{{ datas.channel }}</router-link>
          </div>
          <div class="meta-date">
            <span>{{ datas.createdat }}</span>
          </div>
        </div>
        <h4 class="title">
          <router-link :to="`/articles/${datas.id}`" :key="datas.id">{{ datas.title }}</router-link>
        </h4>
      </div>
    </template>
  </router-link>

  <router-link
    :to="`/articles/${datas.id}`"
    v-else-if="countingtwo"
    class="post-gallery-style-2 most-view-style-2"
  >
    <div class="post-gallery-thumb">
      <img
        :src="datas.coverurl"
        alt="gallery"
      />
      <span>{{ count }}</span>
    </div>
    <div class="post-gallery-content">
      <h5 class="title">
        <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
      </h5>
      <div class="meta-post-2-style">
        <div class="meta-post-categores">
          <router-link :to="`/articles?channel=${datas.orgchannel}`">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-post-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
    </div>
  </router-link>

  <router-link :to="`/articles/${datas.id}`" v-else-if="trending" class="gallery_item">
    <div class="gallery_item_thumb">
      <img
        v-if="datas.coverurl"
        :src="datas.coverurl"
        alt="gallery"
        class="custom-img"
      />
      <!--
      <div v-if="datas.trending" class="icon"><i class="fas fa-bolt"></i></div>
      -->
    </div>
    <div class="gallery_item_content">
      <div class="post-meta">
        <div class="meta-categories">
          <router-link :to="`/articles?channel=${datas.orgchannel}`">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
      <h4 class="title">
        <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
      </h4>
      <!-- <span v-if="counting">{{ counting }}</span> -->
    </div>
  </router-link>

  <router-link
    :to="`/articles/${datas.id}`"
    v-else-if="counting"
    class="gallery_item gallery_item-style-2"
  >
    <div class="gallery_item_thumb">
      <img 
        :src="datas.coverurl" 
        alt="gallery" 
        class="custom-hot-img"
      />
      <div class="icon"><i class="fas fa-bolt"></i></div>
    </div>
    <div class="gallery_item_content">
      <div class="post-meta">
        <div class="meta-categories">
          <router-link :to="`/articles?channel=${datas.orgchannel}`">{{ datas.channel }}</router-link>
        </div>
        <div class="meta-date">
          <span>{{ datas.createdat }}</span>
        </div>
      </div>
      <!-- 使用 flex 布局 -->
      <div class="title-count-container">
        <h4 class="title">
          <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
        </h4>
        <span class="count">{{ count }}</span>
      </div>
    </div>
  </router-link>

  <router-link :to="`/articles/${datas.id}`" v-else-if="sports" class="gallery_item">
    <template v-if="datas">
      <div class="gallery_item_thumb">
        <img
          v-if="datas.coverurl"
          :src="datas.coverurl"
          alt="gallery"
          class="custom-sports-img"
        />
      </div>
      <div class="gallery_item_content">
        <div class="post-meta">
          <div class="meta-categories">
            <router-link :to="`/articles/${datas.id}`">{{ datas.channel }}</router-link>
          </div>
          <div class="meta-date">
            <span>{{ datas.createdat }}</span>
          </div>
        </div>
        <h4 class="title">
          <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>
        </h4>
      </div>
    </template>
  </router-link>

  <router-link
    :to="`/articles/${datas.id}`"
    v-else
    class="single__post d-lg-flex text-center text-lg-left"
  >
    <template v-if="datas">
      <div class="post-thumb mb-3 mb-lg-0">
        <img
          v-if="datas.coverurl"
          :src="datas.coverurl"
          alt="post"
          class="custom-post-img"
        />
      </div>
      <div class="post-content">
        <h4 class="title">
          <router-link :to="`/articles/${datas.id}`">{{ datas.title }}</router-link>

        </h4>
        <p class="line-clumb-one">{{ datas.description }}</p>
      </div>
    </template>
  </router-link>
</template>

<script>
export default {
  props: {
    category: {
      type: Boolean,
    },
    trending: {
      type: Boolean,
    },
    sports: { type: Boolean, default: false },
    datas: {
      type: Object,
    },
    counting: {
      type: Boolean,
    },
    countingtwo: {
      type: Boolean,
    },
    count: {
      type: Number,
    },
  },
};
</script>

<style scoped>
.custom-img {
  width: 100px;
  height: auto;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.title-count-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.title {
  margin: 0;
  flex-grow: 1;
}

.count {
  margin-left: 10px; /* 可根据需要调整间距 */
}

.custom-hot-img {
  width: 80px;
  height: auto;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.custom-post-img {
  width: 80px;
  height: 70px;
  /* 保持图片比例，填充容器，裁剪溢出部分 */
  object-fit: cover;
  /* 显示图片中心部分 */
  object-position: center;
}

.custom-sports-img {
  width: 100px;
  height: auto;
  object-fit: cover;
  object-position: center;
}

</style>
